(function() {
  'use strict';

  angular.module('blocks.list', []);
})();
